export class Locals {
    stype?: string;
    ptype?:number;
    tokenfrom?:any;
    tokento?:any;
    tokens?:any;
    accdetail?:any;
    sprequest?:any;
    addlppl:any;

}


// WEBPACK FOOTER //
// ./src/models/localmodel.ts